/* WK SCROLLBAR - the bead on a rail (owner's choice, 2026-09-29).

   The page's scrollbar is drawn: one hairline rail down the right edge of the
   window, full height like a native scrollbar (the owner tried a bar that
   stopped at the header and the footer and the bead jumping as the rail
   shortened looked wrong), and a bead riding it that marks where you are.
   custom.css "SCROLLBAR" hides the native page scrollbar at >= 769px (no
   hover test: the owner's tablet reports hover:none) and draws the bead; inner scrollers (drawers, dialogs, tables, the portal)
   keep a native scrollbar dressed as a hairline. Wheel, keys and touch still
   scroll the page natively; this only shows position and takes a drag on the
   bead or a click on the rail. It stands down while a drawer or modal holds
   the page, when the page does not scroll, and on phones (the native overlay
   scrollbar is right there). Every page, deferred, from theme.liquid. */
(function () {
  'use strict';
  if (window.wkScrollbar) return;
  window.wkScrollbar = true;

  var root = document.documentElement;
  var media = window.matchMedia ? window.matchMedia('(min-width: 769px)') : { matches: true };
  var bar, rail, thumb;
  var raf = null, dragging = false, dragOff = 0;
  var geo = { span: 1, max: 1, tl: 0 };

  function locked() {
    var c = root.classList, b = document.body.classList;
    if (c.contains('js-drawer-open') || b.contains('js-drawer-open') || c.contains('modal-open') || b.contains('modal-open')) return true;
    return getComputedStyle(root).overflowY === 'hidden' || getComputedStyle(document.body).overflowY === 'hidden';
  }

  var lastPos = -1;
  function update() {
    raf = null;
    if (!bar) return;
    var vh = window.innerHeight, sh = root.scrollHeight, y = window.scrollY || root.scrollTop || 0;
    var max = sh - vh;
    if (!media.matches || max <= 2 || locked()) { bar.hidden = true; return; }
    bar.hidden = false;
    var tl = thumb.offsetHeight;                      /* the bead is a marker, not a proportion */
    var span = Math.max(1, vh - tl);
    var pos = Math.round(span * Math.min(1, Math.max(0, y / max)));
    geo = { span: span, max: max, tl: tl };
    /* Written only on change (sweep 2026-10-07): an unconditional write every 700 ms woke every style observer on the page. */
    if (pos !== lastPos) { lastPos = pos; thumb.style.transform = 'translateY(' + pos + 'px)'; }
  }
  function schedule() { if (!raf) raf = window.requestAnimationFrame(update); }

  function startDrag(e) {
    if (e.button !== 0) return;
    dragging = true;
    dragOff = e.clientY - thumb.getBoundingClientRect().top;
    bar.classList.add('is-dragging');
    root.classList.add('wk-sb-drag');
    try { thumb.setPointerCapture(e.pointerId); } catch (err) {}
    e.preventDefault();
    e.stopPropagation();
  }
  function moveDrag(e) {
    if (!dragging) return;
    var p = e.clientY - dragOff;
    var frac = Math.max(0, Math.min(1, p / geo.span));
    window.scrollTo(0, frac * geo.max);
  }
  function endDrag() {
    if (!dragging) return;
    dragging = false;
    bar.classList.remove('is-dragging');
    root.classList.remove('wk-sb-drag');
  }
  function jump(e) {
    if (e.target === thumb || e.button !== 0) return;
    var p = e.clientY - geo.tl / 2;
    var frac = Math.max(0, Math.min(1, p / geo.span));
    window.scrollTo({ top: frac * geo.max, behavior: 'smooth' });
  }

  function init() {
    bar = document.createElement('div');
    bar.className = 'wk-sb';
    bar.setAttribute('aria-hidden', 'true');
    bar.hidden = true;
    bar.innerHTML = '<div class="wk-sb__rail"><div class="wk-sb__thumb"></div></div>';
    document.body.appendChild(bar);
    rail = bar.firstChild;
    thumb = rail.firstChild;
    thumb.addEventListener('pointerdown', startDrag);
    thumb.addEventListener('pointermove', moveDrag);
    thumb.addEventListener('pointerup', endDrag);
    thumb.addEventListener('pointercancel', endDrag);
    rail.addEventListener('pointerdown', jump);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (media.addEventListener) media.addEventListener('change', schedule);
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(root, { attributes: true, attributeFilter: ['class', 'style'] });
      new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    }
    window.setInterval(schedule, 700);   /* the page grows without an event: images, the calculator, folds */
    update();
  }
  if (document.body) init(); else document.addEventListener('DOMContentLoaded', init);
})();
